import React from 'react';

function FileItem({ f }){
  return (
    <div className="flex items-center justify-between p-3 border rounded-lg">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded bg-gray-100 flex items-center justify-center text-gray-600">{f.type.toUpperCase()}</div>
        <div>
          <div className="font-medium">{f.name}</div>
          <div className="text-xs text-gray-500">{f.size} · {f.uploadedAt}</div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button className="px-2 py-1 rounded bg-white border">↓</button>
        <button className="px-2 py-1 rounded bg-white border">⋯</button>
      </div>
    </div>
  );
}

export default function FilesPanel({ files = [] }){
  return (
    <div className="bg-white rounded-2xl p-4 border">
      <div className="flex items-center justify-between mb-4">
        <h4 className="font-medium">Arquivos do projeto</h4>
        <button className="text-sm text-purple-600">Ver todos</button>
      </div>
      <div className="space-y-3">
        {files.map(f => <FileItem key={f.id} f={f} />)}
      </div>
      <div className="mt-4">
        <button className="w-full px-4 py-2 bg-white border rounded-lg">Adicionar arquivo</button>
      </div>
    </div>
  );
}
